module.exports = __webpack_public_path__ + "img/icon_registration.bf52bf70.png";